import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DetalleDteImpuestoAdicional } from "src/app/models/Dte/DetalleDteImpuestoAdicional";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { Impuesto } from "src/app/models/Impuesto";
import { Producto } from "src/app/models/Producto/Producto";
import { ProductoFilter } from "src/app/models/Producto/ProductoFilter";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { ImpuestoService } from "src/app/services/impuesto.service";
import { ProductoService } from "src/app/services/producto.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { ConfigProductosDetalle } from "src/app/components/facturacion/facturador-individual/cuadro-producto-detalle/config-productos-detalle";
import { PermissionService } from "src/app/services/permission.service";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { Observable, Subject, of, timer } from "rxjs";
import { BuscadorCatalogoService, ResultadoCatalogo } from "src/app/services/buscador-catalogo.service";
import { catchError, switchMap, takeUntil } from "rxjs/operators";
import { Servicio } from "src/app/models/Servicio/Servicio";
import { ServicioFilter } from "src/app/models/Servicio/ServicioFilter";
import { ServicioService } from "src/app/services/servicios.service";
@Component({
   selector: "app-cuadro-producto-detalle",
   templateUrl: "./cuadro-producto-detalle.component.html",
   styleUrls: ["./cuadro-producto-detalle.component.scss"],
})
export class CuadroProductoDetalleComponent implements OnInit, OnDestroy {
   @Output() verDocumentos = new EventEmitter<void>();
   public loading: boolean = false;
   public isProductMode: boolean = true;
   public searchCatalog: ResultadoCatalogo[] = [];
   public mostrarResultado = () => true;
   public searchLoading: boolean = false;
   public currentProduct: Producto = new Producto();
   public detalleProductoFormGroup: FormGroup;
   public detalleDte: DetalleDte = new DetalleDte();
   public currentInvoiceType: InvoiceType = InvoiceType.Factura;
   private currentEmisorId = this.tokenService.getCompany();
   private sucursalId: string = this.tokenService.getSubsidiary();
   public usuarioId: string;
   public workWithProduct: boolean = true;
   public productRows: Producto[] = [];
   public pageProducts = new Page();
   private productFilter = new ProductoFilter();
   public serviceRows: Servicio[] = [];
   public pageServices = new Page();
   private serviceFilter = new ServicioFilter();
   private productListModalRef: any;
   public configLocal = ConfigProductosDetalle;
   public currentSearchConfig: any;
   private createProductModal: any;
   private createServiceModal: any;
   public opciones: OptionsReferenceDteEmitido = new OptionsReferenceDteEmitido();
   private opcionesObservable$: Observable<OptionsReferenceDteEmitido>;
   public consultandoProducto: boolean = false;
   public hasCatalogSelection: boolean = false;
   private searchSubject = new Subject<string>();
   private destroy$ = new Subject<void>();
  
   constructor(private catalogo: BuscadorCatalogoService, private impuestoService: ImpuestoService, private ref: ChangeDetectorRef, private formBuilder: FormBuilder, private facturador: FacturacionIndividualService, private tokenService: TokenStorageService, private productoService: ProductoService, private utilities: UtilitiesService, private modalService: NgbModal, public permissions: PermissionService, public servicioService: ServicioService) {
      this.productFilter.emisorId = this.currentEmisorId;
      this.productFilter.sucursalId = this.sucursalId;
      this.serviceFilter.emisorId = this.currentEmisorId;
      this.serviceFilter.sucursalId = this.sucursalId;
      this.pageProducts.pageSize = 10;
      this.pageServices.pageSize = 10;
      this.pageProducts.totalElements = 0;
      this.pageServices.totalElements = 0;
      this.opcionesObservable$ = this.facturador.opcionesReferenciaObservable;
         this.usuarioId = this.tokenService.getUser().id;

   }

   ngOnInit(): void {
      this.setForm();
      this.initializeSearchConfig();
      this.opcionesObservable$.pipe(takeUntil(this.destroy$)).subscribe((opciones) => {
         this.opciones = opciones;
         //this.onSubmit()
      });

      this.facturador.currentInvoiceTypeObservable.pipe(takeUntil(this.destroy$)).subscribe(type => {
         this.currentInvoiceType = type;
      });
      this.searchSubject.pipe(
         switchMap(term => {
            this.searchLoading = !!term.trim();
            this.searchCatalog = [];
            return term.trim()
               ? timer(300).pipe(
                    switchMap(() => this.catalogo.buscar(term, this.currentEmisorId, this.sucursalId)),
                    catchError(() => {
                       Swal.fire({ icon: "error", title: "No pudimos buscar", text: "Intente buscar el producto o servicio nuevamente." });
                       return of([]);
                    })
                 )
               : of([]);
         }),
         takeUntil(this.destroy$)
      ).subscribe(results => {
         this.searchCatalog = results;
         this.searchLoading = false;
         this.ref.detectChanges();
      });
   }

   seleccionarResultado(resultado: ResultadoCatalogo): void {
      if (!resultado || this.consultandoProducto) return;
      if (resultado.producto) {
         this.refreshItemDetail(resultado.producto);
      } else if (resultado.servicio) {
         this.selectedServiceToForm(resultado.servicio);
         this.onSubmit();
      }
   }

   refreshItemDetail(event: Producto) {
      if (!event?.productoId || this.consultandoProducto) return;
      this.currentProduct = { ...event };
      this.hasCatalogSelection = true;
      this.getTaxesOfProduct(this.currentProduct);
   }

   clearProduct($event?) {
      this.currentProduct = new Producto();
      this.hasCatalogSelection = false;
      this.detalleProductoFormGroup.patchValue({ catalogo: null, codigo: null, nombreItem: null });
   }

   getTaxesOfProduct(prod: Producto) {
      this.consultandoProducto = true;
      this.impuestoService.taxesByProduct(prod).pipe(takeUntil(this.destroy$)).subscribe(
         res => {
            this.currentProduct = { ...prod, impuestos: res.data as Impuesto[] };
            this.selectedProductToForm(this.currentProduct);
            this.consultandoProducto = false;
            this.onSubmit();
            this.ref.detectChanges();
         },
         () => {
            this.consultandoProducto = false;
            this.clearProduct();
            this.ref.detectChanges();
            Swal.fire({
               icon: "error", title: "No pudimos agregar el producto",
               text: "No fue posible obtener sus impuestos. Seleccione el producto nuevamente para reintentar.",
            });
         }
      );
   }

   selectedProductToForm(selectedProduct: Producto) {
      if (selectedProduct) {
         this.isProductMode = true; 
         this.hasCatalogSelection = true;
         this.detalleProductoFormGroup.controls.productId.patchValue(selectedProduct.productoId);
         this.detalleProductoFormGroup.controls.codigo.patchValue(selectedProduct.codigoBarra);
         this.detalleProductoFormGroup.controls.precioUnitario.patchValue(selectedProduct.precio);
         let ExentoValue = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : selectedProduct.exento;
         this.detalleProductoFormGroup.controls.exento.patchValue(ExentoValue);
         this.detalleProductoFormGroup.controls.nombreItem.patchValue(selectedProduct.nombre);
         this.detalleDte.createCurrentProduct = false;
         if (selectedProduct.impuestos != undefined) {
            let detalleDteImpuestoAdicionalList: DetalleDteImpuestoAdicional[] = [];
            let impuestoFromProduct = [...selectedProduct.impuestos];
            impuestoFromProduct = [...impuestoFromProduct];
            detalleDteImpuestoAdicionalList = impuestoFromProduct.map((i) => {
               let impuestoAdicional = new DetalleDteImpuestoAdicional();
               impuestoAdicional.codigoSii = i.tipoImpuesto;
               impuestoAdicional.nombreImp = i.nombre;
               impuestoAdicional.valor = Math.round((i.valor / 100) * this.detalleDte.total);
               impuestoAdicional.nroImp = selectedProduct.impuestos.indexOf(i) + 1;
               impuestoAdicional.tasa = i.valor;
               impuestoAdicional.impuestoIdRelated = i.impuestoId;
               return impuestoAdicional;
            });
            this.detalleDte.impuestosAdicionales = [...detalleDteImpuestoAdicionalList];
            this.detalleDte.impuestosAdicionales = [...this.detalleDte.impuestosAdicionales];
         } else {
            this.detalleDte.impuestosAdicionales = [];
         }

         if (selectedProduct.unidadMedida != undefined && selectedProduct.unidadMedida != "") {
            this.detalleProductoFormGroup.controls.unidadMedida.patchValue(selectedProduct.unidadMedida);
            //this.detalleFormGroup.controls.haveDescripcion.patchValue(true);
         }
         this.searchCatalog = [];
         this.ref.detectChanges();
      }
   }

   onSubmit(formLocalRef?: FormGroupDirective) {
      if (this.detalleProductoFormGroup.valid && !this.consultandoProducto && this.hasCatalogSelection) {
         let newDetail = new DetalleDte();
         this.detalleDte = newDetail;
         this.detalleDte.cantidad = 1;
         this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion || !!this.detalleProductoFormGroup.controls.exento.value;
         this.detalleDte.codigoInterno = this.detalleProductoFormGroup.controls.codigo.value;
         this.detalleDte.nombre = this.detalleProductoFormGroup.controls.nombreItem.value;
         //this.detalleDte.descripcion = this.detalleDte.nombre;
         this.detalleDte.precioUnitario = this.detalleProductoFormGroup.controls.precioUnitario.value;
         this.detalleDte.unidadMedida = this.detalleProductoFormGroup.controls.unidadMedida.value;
         this.detalleDte.subtotal = this.detalleDte.precioUnitario * this.detalleDte.cantidad;
         this.detalleDte.total = this.detalleDte.subtotal;
         if (this.isProductMode) {
            newDetail.relatedProductId = this.detalleProductoFormGroup.controls.productId.value;
            newDetail.relatedProduct   = { ...this.currentProduct };
            newDetail.createCurrentProduct = this.detalleDte.createCurrentProduct; // si aplicas alta de producto nuevo

            if (this.detalleDte.relatedProduct && this.currentProduct.impuestos != undefined) {
               let detalleDteImpuestoAdicionalList: DetalleDteImpuestoAdicional[] = [];
               let impuestoFromProduct = [...this.currentProduct.impuestos];
               impuestoFromProduct = [...impuestoFromProduct];
               detalleDteImpuestoAdicionalList = impuestoFromProduct.map((i) => {
                  let impuestoAdicional = new DetalleDteImpuestoAdicional();
                  impuestoAdicional.codigoSii = i.tipoImpuesto;
                  impuestoAdicional.nombreImp = i.nombre;
                  impuestoAdicional.valor = Math.round((i.valor / 100) * this.detalleDte.total);
                  impuestoAdicional.nroImp = this.currentProduct.impuestos.indexOf(i) + 1;
                  impuestoAdicional.tasa = i.valor;
                  impuestoAdicional.impuestoIdRelated = i.impuestoId;
                  return impuestoAdicional;
               });
               this.detalleDte.impuestosAdicionales = [...detalleDteImpuestoAdicionalList];
               this.detalleDte.impuestosAdicionales = [...this.detalleDte.impuestosAdicionales];
            } else {
                  this.detalleDte.impuestosAdicionales = [];
            }
         } else {
            newDetail.relatedProductId     = null;
            newDetail.relatedProduct       = null;
            newDetail.impuestosAdicionales = [];
            newDetail.createCurrentProduct = false;
            this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : this.detalleProductoFormGroup.controls.exento.value;
         }
         this.facturador.publishProductDetail(this.detalleDte);
         formLocalRef?.resetForm();
         this.searchSubject.next("");
         this.clearProduct();
         this.detalleProductoFormGroup.reset();
         this.detalleProductoFormGroup.controls.cantidad.patchValue(1);
         this.detalleDte = new DetalleDte();
         this.hasCatalogSelection = false;
         this.detalleProductoFormGroup.updateValueAndValidity();
      }
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
      this.searchSubject.complete();
    }
  
   searchItem(event: { term: string }): void {
      this.hasCatalogSelection = false;
      this.searchSubject.next(event.term);
    }
    

   AddProductByName = (prod: string) => {
      this.detalleProductoFormGroup.get("nombreItem").patchValue(prod);
      if (!this.detalleProductoFormGroup.get("codigo").value || this.detalleProductoFormGroup.get("codigo").value == "") {
         Swal.fire({
            icon: "question",
            title: "¿Agregar nuevo producto?",
            text: 'Para agregar el nuevo producto de nombre "' + prod + '", ingrese además un código de producto en el Selector de producto por Código y presione la opción de "Agregar Producto" en la pestaña de dicho selector. Este producto será agregado si la transacción se realiza con éxito. En caso contrario, realice una nueva búsqueda y seleccione un producto existente.',
         });
         return;
      }
      this.detalleDte.nombre = prod;
      //this.detalleDte.codigoInterno = "";
      this.detalleDte.codigoInterno = this.detalleProductoFormGroup.get("codigo").value;
      this.detalleDte.nombre = this.detalleProductoFormGroup.get("nombreItem").value;
      this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : this.detalleProductoFormGroup.controls.exento.value;
      this.detalleDte.createCurrentProduct = true;
      this.workWithProduct = null;
   };

   setForm() {
      this.detalleProductoFormGroup = this.formBuilder.group({
         catalogo: [],
         codigo: [],
         nombreItem: [,],
         precioUnitario: [,],
         exento: [],
         unidadMedida: [],
         cantidad: [1],
         productId: [],
      });
   }

   AddProductByCode = (code: string) => {
      this.detalleProductoFormGroup.get("codigo").patchValue(code);
      if (!this.detalleProductoFormGroup.get("nombreItem").value || this.detalleProductoFormGroup.get("nombreItem").value == "") {
         Swal.fire({
            icon: "question",
            title: "¿Agregar nuevo producto?",
            text: 'Para agregar el nuevo producto de código "' + code + '", ingrese además un nombre nuevo para el producto en el Selector de producto por Nombre y presione la opción de "Agregar Producto" en la pestaña de dicho selector. Este producto será agregado si la transacción se realiza con éxito. En caso contrario, realice una nueva búsqueda y seleccione un producto existente.',
         });
         return;
      }
      this.detalleDte.codigoInterno = code;
      this.detalleDte.nombre = this.detalleProductoFormGroup.get("nombreItem").value;
      this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : this.detalleProductoFormGroup.controls.exento.value;
      this.detalleDte.createCurrentProduct = true;
      this.workWithProduct = null;
   };

   setPageProducts(pageInfo) {
      this.loading = true;
      const requestPage = { ...this.pageProducts, pageNumber: pageInfo.offset + 1 };

      this.productoService
         .getDataByPage(this.productFilter, requestPage)
         .subscribe(
            (pagedData) => {
               let elements = pagedData.data as Producto[];
               // this.ref.detectChanges();
               // elements.forEach((row) => {});
               // this.productRows = [...elements];
               this.productRows = elements;
               this.setPagefromSucursalResponse(this.pageProducts, pagedData);
               this.loading = false;
               this.ref.detectChanges();
            },
            (error) => {
               this.loading = false;
               Swal.fire({
                  icon: "error",
                  title: "Error en la solicitud",
                  text: this.utilities.setErrorMessageFromArray(error.error),
               });
            },
            () => {
               this.loading = false;
               this.ref.detectChanges();
            }
         )
         .add(() => {
            this.loading = false;
            this.ref.detectChanges();
         });
   }

   setPagefromSucursalResponse(currentPage: Page, data: PagedResponse<Producto>) {
      currentPage.pageSize = data.pageSize;
      currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
      currentPage.totalPages = data.totalPages;
      currentPage.totalElements = data.totalRecords;
   }

   openProducListModal(modalRef) {
      if (this.currentInvoiceType === InvoiceType.LiquidacionFactura) {
         this.verDocumentos.emit();
         return;
      }
      this.isProductMode = true;
      this.updateSearchConfig();
      this.productFilter.nombre = null;
      this.productFilter.codigoBarra = null;
      this.setPageProducts({ offset: 0 });
      this.productListModalRef = this.modalService.open(modalRef, {
         windowClass: "",
         size: "xl",
      });
   }

   onActivate(event) {
      if (this.loading || this.consultandoProducto) return;
      if (event.type == "click") {
         if (this.isProductMode) {
            this.refreshItemDetail(event.row);
         } else {
            if (this.consultandoProducto) return;
            this.selectedServiceToForm(event.row as Servicio);
            this.onSubmit();
         }
         this.productListModalRef.close();
      }
   }

   searchElementsByFilter(event) {
      if (this.isProductMode) {
         let filterLocal = new ProductoFilter();
         this.productFilter = { ...filterLocal };
         this.productFilter[event.criterio] = event.busqueda;
         this.productFilter.activo = event.registroActivo;
         this.productFilter.exento = event.productoExento;
         this.productFilter.emisorId = this.currentEmisorId;
         this.productFilter.sucursalId = this.sucursalId;
         this.setPageProducts({ offset: 0 });
      } else {
         let filterLocal = new ServicioFilter();
         this.serviceFilter = { ...filterLocal };
         this.serviceFilter[event.criterio] = event.busqueda;   // normalmente será 'nombre'
         this.serviceFilter.activo = event.registroActivo;
         this.serviceFilter.exento = event.productoExento;
         this.serviceFilter.emisorId = this.currentEmisorId;
         this.serviceFilter.sucursalId = this.sucursalId;
         this.setPageServices({ offset: 0 });
      }
   }

   openCreateProductModal(modalRef) {
      this.createProductModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
      });
   }
   openCreateServiceModal(modalRef) {
      this.createServiceModal = this.modalService.open(modalRef, {
         windowClass: "",
         size: "lg",
      });
   }
   closeCreateModal() {
      if (this.isProductMode){
         this.createProductModal.close();
      } else {
         this.createServiceModal.close();
      }
   }

   productWithTaxesRequest(event: Producto) {
      if (!event.impuestos || event.impuestos.length <= 0) {
         this.sendNewProductOnly(event);
      } else {
         this.sendNewProductWithTaxes(event);
      }
   }
   selectedServiceToForm(selectedService: Servicio) {
      if (selectedService) {
         this.isProductMode = false;  
         this.hasCatalogSelection = true;
         // aquí usamos los mismos controles del form
         this.detalleProductoFormGroup.controls.productId.patchValue(null); // o un control nuevo si quieres
         this.detalleProductoFormGroup.controls.codigo.patchValue("");      // los servicios no usan código de barra
         this.detalleProductoFormGroup.controls.precioUnitario.patchValue(selectedService.precio);
         this.detalleProductoFormGroup.controls.exento.patchValue(selectedService.exento);
         this.detalleProductoFormGroup.controls.nombreItem.patchValue(selectedService.nombre);
         
         // al ser servicio, no hay impuestos adicionales ligados como al producto
         this.detalleDte.impuestosAdicionales = [];

         this.searchCatalog = [];
         this.ref.detectChanges();
      }
   }

   sendNewProductOnly(event: Producto) {
      event.emisorId = this.currentEmisorId;
      event.sucursalId = this.sucursalId;
      this.loading = true;
      this.ref.detectChanges();
      this.productoService
         .sendProductRequest(event)
         .subscribe(
            (result) => {
               this.ref.detectChanges();

               this.setPageProducts({ offset: 0 });
               this.ref.detectChanges();
               Swal.fire({
                  icon: "success",
                  title: "Ingreso de Producto",
                  text: "Se ha guardado el producto ingresado exitosamente.",
               });
            },
            (error) => {
               Swal.fire({
                  icon: "error",
                  title: "Error en Producto",
                  text: "No ha sido posible guardar el producto ingresado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
               });
            }
         )
         .add(() => {
            this.loading = false;
            this.closeCreateModal();
            this.ref.detectChanges();
         });
   }
   sendNewServiceOnly(event: Servicio) {
       event.emisorId = this.currentEmisorId;
       event.sucursalId = this.sucursalId;
       event.usuarioCreo = this.usuarioId;
       this.loading = true;
       this.ref.detectChanges();
       this.servicioService
         .sendServiceRequest(event)
         .subscribe(
           (result) => {
               this.ref.detectChanges();
               this.setPageServices({ offset: 0 });
               this.ref.detectChanges();
               Swal.fire({
                 icon: "success",
                 title: "Ingreso de Servicio",
                 text: "Se ha guardado el servicio ingresado exitosamente.",
               });
           },
           (error) => {
               Swal.fire({
                 icon: "error",
                 title: "Error en Servicio",
                 text: "No ha sido posible guardar el servicio ingresado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
               });
           }
         )
         .add(() => {
           this.loading = false;
           this.closeCreateModal();
           this.ref.detectChanges();
         });
     }
   sendNewProductWithTaxes(event: Producto) {
      event.emisorId = this.currentEmisorId;
      event.sucursalId = this.sucursalId;

      this.loading = true;
      this.ref.detectChanges();
      this.productoService
         .sendProductRequest(event)
         .subscribe(
            (result) => {
               this.ref.detectChanges();
               let newProduct = result.data as Producto;
               if (event.impuestos) {
                  newProduct.impuestos = event.impuestos;
                  this.loading = true;
                  this.productoService.updateTaxes(newProduct).subscribe(
                     (result) => {
                        this.loading = false;
                        this.setPageProducts({ offset: 0 });
                        this.ref.detectChanges();
                        Swal.fire({
                           icon: "success",
                           title: "Ingreso de Producto",
                           text: "Se ha guardado el producto ingresado exitosamente.",
                        });
                     },
                     (error) => {
                        let errorText = error.error.message;
                        this.loading = false;
                        Swal.fire({
                           icon: "error",
                           title: "Error en Producto",
                           text: "No ha sido posible guardar el producto ingresado, intente nuevamente. " + errorText,
                        });
                     }
                  );
               }
            },
            (error) => {
               Swal.fire({
                  icon: "error",
                  title: "Error en Producto",
                  text: "No ha sido posible guardar el producto ingresado, intente nuevamente. " + this.utilities.setErrorMessageFromArray(error.error),
               });
            }
         )
         .add(() => {
            this.loading = false;
            this.closeCreateModal();
            this.ref.detectChanges();
         });
   }
   setMode(isProduct: boolean): void {
      this.isProductMode = isProduct;
      this.hasCatalogSelection = false;
      this.clearProduct();
      this.updateSearchConfig();

      if (this.isProductMode) {
         this.setPageProducts({ offset: 0 });
      } else {
         this.setPageServices({ offset: 0 });
      }
   }
   
   initializeSearchConfig(): void {
      this.updateSearchConfig();
   }

   updateSearchConfig(): void {
      if (this.isProductMode) {
         this.currentSearchConfig = {
            criterios: ["Nombre Producto", "Codigo de Barra"],
            criteriosKeys: ["nombre", "codigoBarra"],
            criterioPrincipal: "Nombre Producto",
         };
      } else {
         this.currentSearchConfig = {
            criterios: ["Nombre Servicio"],
            criteriosKeys: ["nombre"],
            criterioPrincipal: "Nombre Servicio",
         };
      }
   }
   
   setPageServices(pageInfo) {
      this.loading = true;
      const requestPage = { ...this.pageServices, pageNumber: pageInfo.offset + 1 };

      this.servicioService
         .getDataByPage(this.serviceFilter, requestPage)
         .subscribe(
            (pagedData) => {
            const elements = pagedData.data as Servicio[];
            this.serviceRows = elements;
            this.setPageFromServiceResponse(this.pageServices, pagedData);
            this.loading = false;
            this.ref.detectChanges();
            },
            (error) => {
            this.loading = false;
            Swal.fire({
               icon: "error",
               title: "Error en la solicitud",
               text: this.utilities.setErrorMessageFromArray(error.error),
            });
            },
            () => {
            this.loading = false;
            this.ref.detectChanges();
            }
         )
         .add(() => {
            this.loading = false;
            this.ref.detectChanges();
         });
   }

   setPageFromServiceResponse(currentPage: Page, data: PagedResponse<Servicio>) {
      currentPage.pageSize = data.pageSize;
      currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
      currentPage.totalPages = data.totalPages;
      currentPage.totalElements = data.totalRecords;
   }

   get paginaCatalogo(): Page {
      return this.isProductMode ? this.pageProducts : this.pageServices;
   }

   get filasCatalogo(): Array<Producto | Servicio> {
      return this.isProductMode ? this.productRows : this.serviceRows;
   }

   cambiarPaginaCatalogo(pagina: number): void {
      if (this.loading) return;
      if (this.isProductMode) this.setPageProducts({ offset: pagina - 1 });
      else this.setPageServices({ offset: pagina - 1 });
   }

   cambiarTamanoCatalogo(tamano: number): void {
      if (this.loading || ![10, 25, 50].includes(tamano)) return;
      this.paginaCatalogo.pageSize = tamano;
      this.cambiarPaginaCatalogo(1);
   }
   

}
